export default __webpack_public_path__ + "static/media/arrow_down.fbfb0ceb.svg";